import { dew as _callDew } from "./twilio/call";
import { dew as _deviceDew } from "./twilio/device";
import { dew as _errorsDew } from "./twilio/errors";
import { dew as _logDew } from "./twilio/log";
import { dew as _preflightDew } from "./twilio/preflight/preflight";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.TwilioError = exports.Logger = exports.PreflightTest = exports.Device = exports.Call = void 0;
  /**
   * @packageDocumentation
   * @internalapi
   */
  var call_1 = _callDew();
  exports.Call = call_1.default;
  var device_1 = _deviceDew();
  exports.Device = device_1.default;
  var TwilioError = _errorsDew();
  exports.TwilioError = TwilioError;
  var log_1 = _logDew();
  Object.defineProperty(exports, "Logger", {
    enumerable: true,
    get: function () {
      return log_1.Logger;
    }
  });
  var preflight_1 = _preflightDew();
  Object.defineProperty(exports, "PreflightTest", {
    enumerable: true,
    get: function () {
      return preflight_1.PreflightTest;
    }
  });
  //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHdpbGlvLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vbGliL3R3aWxpby50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQTs7O0dBR0c7QUFDSCxzQ0FBaUM7QUFNeEIsZUFORixjQUFJLENBTUU7QUFMYiwwQ0FBcUM7QUFLdEIsaUJBTFIsZ0JBQU0sQ0FLUTtBQUpyQiw2Q0FBK0M7QUFJRCxrQ0FBVztBQUh6RCxvQ0FBc0M7QUFHQSx1RkFIN0IsWUFBTSxPQUc2QjtBQUY1QywwREFBNkQ7QUFFdEMsOEZBRmQseUJBQWEsT0FFYyJ9
  return exports;
}